<template>
  <div class="navbar navbar-expand-md navbar-dark fixed-top head-box">
    <a href="/" title="招鲤视频" class="navbar-brand">
      <h1>
        <img
          class="logo"
          src="https://p.cdn.izhaoli.cn/official_website/website/logo@2x.png"
          alt="logo"
          title="logo"
        />
      </h1>
    </a>
    <div class="charge-btn-box">
      <div @click="showMak">
        {{lang}}
        <i class="iconfont icon-xiangxia"></i>
      </div>
      <div class="btn-list_box" v-if="maskState">
        <div
          class="charge-btn-list"
          :class="current==i?'btn-active':''"
          v-for="(item, i) in langList"
          :key="i"
          @click="changeLocale(item.lang,i)"
        >{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      langList: [
        {
          name: "Englist",
          lang: "en"
        },
        {
          name: "中文",
          lang: "zh"
        }
      ],
      current: 0,
      lang: "en",
      maskState: false
    };
  },
  created() {
    this.changeLocale(this.lang, this.current);
  },
  methods: {
    showMak() {
      this.maskState = true;
    },
    changeLocale(lang, i) {
      this.current = i;
      if (lang === "zh") {
        this.lang = "中文";
        this.$i18n.locale = lang; //关键语句
        document.title = "招鲤科技-招鲤让视频营销更简单";
        document.getElementsByTagName("meta")[3].content =
          "zhaoli,招鲤,鬼手剪辑,懒猫智能,GhostCut,JollyToday,视频去水印,视频去字幕,视频翻译,视频混剪,视频模板,视频脚本,视频电商...";
        document.getElementsByTagName("meta")[4].content =
          "招鲤团队把未来投入到指数级增长的领域，拥抱数据、算法和算力，致力于用视频和算法提升消费者的选购体验。";
      } else {
        this.lang = "English";
        this.$i18n.locale = lang; //关键语句
        document.title = "JollyToday-Video Marketing,Made Easier.";
        document.getElementsByTagName("meta")[3].content =
          "zhaoli,, GhostCut, DozyCat, JollyToday, video watermark removal, video subtitle removal, video translation, video mixing, video templates, video scripts, video e-commerce...";
        document.getElementsByTagName("meta")[4].content =
          "In an area with great potential of growing exponentially, we devote to improve shopping experience of consumer by making full use of video, data, algorithms, and computing power.";
      }
      this.maskState = false;
    }
  }
};
</script>


<style scoped>
.head-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  width: 115px;
  height: 49px;
}
.charge-btn-box {
  width: 107px;
  position: relative;
  font-size: 16px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.btn-list_box {
  position: absolute;
  left: 0;
  top: 30px;
  width: 107px;
  height: 68px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-content: center;
  justify-content: space-around;
  flex-direction: column;
}
.btn-active {
  color: #fff;
}

@media (max-width: 750px) {
  .charge-btn-box {
    margin-right: -20px;
  }
  .btn-list_box {
    width: 85px;
    left: 10px;
  }
}
</style>
